import { ColDef, ICellRendererParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { useEffect, useState } from 'react';
import { LoadChannels } from "../../actions";
import { ChannelContactModel, ChannelType, Contact, CustomFieldModel, mapToChannelContactItem, mapToCustomFields } from '../../models/conversations';
import { UtilityService } from '../../services/UtilityService';
import { ActionLabels, buttonLabels, emptyLabels, pageTitles } from '../shared/constants';
import GridComponent from '../shared/grid';
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { AvatarRenderer } from '../shared/grid/avatarRenderer';
import { Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, MenuItem, Select, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import PullToRefresh from "react-simple-pull-to-refresh";
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import { AddContactIcon, CancelIcon, ChannelsGridEmptyIcon, ContactsChatIcon, EditContactIcon, ExpandMoreIcon, FacebookActiveIcon, FbBadgeIcon, GoogleBusinessIcon, InstaActiveIcon, InstaBadgeIcon, LiveChatConversationCardIcon, LiveChatIcon, WatsappConversationCardIcon, WhatsappActiveIcon, } from "../../icon";
import { ChannelUserModel, mapToChannelUser } from '../../models/users.model';
import * as selector from '../../selectors/selectors';
import { AppRoutes } from "../routes/route.path";
import { CustomFilterCategory } from '../shared/filters/filter.model';
import PageHeaderComponent from "../shared/page-header.component";
import { Link, useNavigate } from 'react-router-dom';
import SelectChannelSideBarComponent from '../channels/select-channel-side-bar-component';
import { ChannelAccountModel, ChannelAccountStatus } from '../../models/channels/channels.model';
import ButtonComponent from '../shared/button/button.component';
import ChannelEditContactComponent from './channel-edit-contact.component';
import ContactAddCustomField from './contact-add-custom-field.component';
import { ChannelContactServices } from '../../services/channels/ChannelContactService';
import LivechatValidationPendingIcon from "../../icons/live-chat-validation-pending-icon.svg";
import LivechatDisconnectedIcon from "../../icons/live-chat-disconnected-icon.svg";
import { MenuItemRenderer } from '../shared/grid/actionsMenuItemRendrer';
import NoDataComponent from '../conversations/no-data-component';
import ConversationCardsHeader from '../conversations/channels-conversation-cards-header';
import { active } from 'd3-transition';




const ContactsComponent = () => {
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;

	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
	const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
	const ActiveChannelsTypes: number[] = useSelector(selector.ActiveChannelsTypes)
	const LoadingChannels: boolean = useSelector(selector.LoadingChannels)

	const initialChannelOptions = [
		{ Label: "Facebook", ChannelType: ChannelType.FACEBOOK, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.FACEBOOK).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.FACEBOOK).map((x) => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: FacebookActiveIcon, Icon: FacebookActiveIcon, Active: ActiveChannelsTypes.includes(1), SubOptionsOpen: false },
		{ Label: "Instagram", ChannelType: ChannelType.INSTAGRAM, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.INSTAGRAM).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.INSTAGRAM).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: InstaActiveIcon, Icon: InstaActiveIcon, Active: (ActiveChannelsTypes.includes(2) && !ActiveChannelsTypes.includes(1)), SubOptionsOpen: false },
		{ Label: "Livechat", ChannelType: ChannelType.LIVE_CHAT, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.LIVE_CHAT).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.LIVE_CHAT).map((x) => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: LiveChatConversationCardIcon, Icon: LiveChatConversationCardIcon, Active: (ActiveChannelsTypes.includes(4) && !ActiveChannelsTypes.includes(1) && !ActiveChannelsTypes.includes(2)), SubOptionsOpen: false },
		{ Label: "Google Business Messages", ChannelType: ChannelType.GOOGLE_BUSINESS, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.GOOGLE_BUSINESS).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.GOOGLE_BUSINESS).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: GoogleBusinessIcon, Icon: GoogleBusinessIcon, Active: false, SubOptionsOpen: false },
		{ Label: "Whatsapp", ChannelType: ChannelType.WHATSAPP, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.WHATSAPP).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.WHATSAPP).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: WhatsappActiveIcon, Icon: WhatsappActiveIcon, Active: (ActiveChannelsTypes.includes(3) && !ActiveChannelsTypes.includes(1) && !ActiveChannelsTypes.includes(2) && !ActiveChannelsTypes.includes(4)), SubOptionsOpen: false }
	]

	const [contactToEdit, setContactToEdit] = useState<ChannelContactModel>();
	const [mobileMenu, setMobileMenu] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [gridApi, setGridApi] = useState<any>();

	const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);

	const [channelContactsData, SetChannelContactsData] = useState<ChannelContactModel[]>([])
	const [loadingChannelContactsData, SetLoadingChannelContactsData] = useState<boolean>(false)
	const [channelOptions, setChannelOptions] = useState<any[]>(initialChannelOptions);
	const [sidebarWidth, setSidebarWidth] = useState<number>(IsMobileDevice ? 10 : 24);
	const [rowData, setRowData] = useState<any[]>();
	const [activeChannel, setActiveChannel] = useState<any>("");
	const [customFields, SetCustomFields] = useState<CustomFieldModel[]>([])
	const [viewFields, SetViewFields] = useState<CustomFieldModel[]>([])
	const [openViewField, setOpenViewField] = useState<boolean>(false)
	const [openCustomField, setOpenCustomField] = useState<boolean>(false)
	const [showAllCustomFields, setShowAllCustomFields] = useState<boolean>(false)
	const [customGridColumns, setCustomGridColumns] = useState<ColDef[]>([])
	const [showChannelContactEdit, setShowEditChannelContactEdit] = useState<boolean>(false);
	const [channelContactToEdit, setChannelContactToEdit] = useState<ChannelContactModel>();
	const [openDropDown, setOpenDropDown] = useState<boolean>(false)


	useEffect(() => {
		if (!!ActiveChannelsTypes.length && !!Channels.length) {
			let initialActiveChannel = initialChannelOptions.find(x => ActiveChannelsTypes.includes(x.ChannelType))
			setChannelOptions(initialChannelOptions.map(x => x.Label === initialActiveChannel.Label ? { Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: IsMobileDevice ? false : Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: initialActiveChannel.Icon, ActiveIcon: initialActiveChannel.ActiveIcon, Active: true, SubOptionsOpen: true } : x))
			setActiveChannel({ Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: IsMobileDevice ? false : Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: initialActiveChannel.Icon, ActiveIcon: initialActiveChannel.ActiveIcon, Active: true, SubOptionsOpen: true })
		}
	}, [Channels, ActiveChannelsTypes])


	const ChannelContactColumnDefs: ColDef[] = [
		{
			field: "FirstName",
			headerName: "Name",
			valueGetter: (params: ValueGetterParams) => {
				return `${params.data.FirstName}`
			},
			cellRendererSelector: (params: ICellRendererParams) => {
				const AvatarComponent = {
					component: AvatarRenderer,
					params: {
						SetName: params.data.FirstName,
						ShowBadgeIcon: false,
						HideAvatar: IsMobileDevice,
					}
				}
				if (params.data) {
					return AvatarComponent
				}
				return undefined
			},
			wrapText: IsMobileDevice ? true : false,
			autoHeight: IsMobileDevice ? true : false,
			resizable: true,
			cellStyle: !IsMobileDevice ? { textOverflow: 'ellipsis', display: "flex", alignItems: "center" } : { display: "flex" },
			minWidth: IsMobileDevice ? null : 200,
		},
		{
			field: "Email",
			headerName: "Email",
			hide: IsMobileDevice,
			cellRenderer: params =>
				<span onClick={(e) => e.stopPropagation()} className={`color-grid-link c-pointer ph-no-capture`} >
					<a href={`mailto:${params.data.Email || ''}`}>{params.data.Email || ''}</a>
				</span>,
			cellStyle: { textOverflow: 'ellipsis', display: "flex", alignItems: "center" },
			minWidth: 150,
		},
		{
			field: "CreatedDateTime",
			headerName: "First Connected",
			valueGetter: (params: ValueGetterParams) => UtilityService.convertToDateTimeFormat(params.data.CreatedDateTime),
			valueFormatter: (params: ValueFormatterParams) => {
				return UtilityService.convertToDateTimeFormat(params.data.CreatedDateTime)
			},
			hide: IsMobileDevice,
		},
		{
			field: "LastMessageActivity",
			headerName: "Last Connected",
			valueFormatter: (params: ValueFormatterParams) => {
				return UtilityService.convertToDateTimeFormat(params.data.LastMessageActivity || new Date()).toString()
			},
			sort: 'desc',
		},
		...customGridColumns,
		{
			field: "ChannelId",
			headerName: "Chat",
			cellRenderer: params =>
				<div className='h5-medium py-1 px-2 d-flex align-center bg-color-chat-button color-primary-light br-2 c-pointer' onClick={() => handleOpenChat(params.data)} >
					<ContactsChatIcon className='mr-1' />
					Chat
				</div>,
		},
		{
			field: "Action",
			maxWidth: 40,
			headerName: "",
			pinned: "right",
			lockPinned: true,
			lockPosition: "right",
			cellClass: "ag-cell-actions-style",
			headerClass: "bg-color-secondary",
			cellRenderer: params =>
				<ActionsRenderer
					MenuData={getChannelMenuActions(params.data)}
					{...params}
				/>,
			resizable: false,
			sortable: false,
			hide: IsMobileDevice,
		},
	]

	const getChannelMenuActions = (data: ChannelContactModel) => {
		return [
			{
				Name: ActionLabels.EDIT,
				Icon: EditContactIcon,
				OnClick: () => openChannelEditContact(data as ChannelContactModel),
			},
		]
	}

	useEffect(() => {
		if (!Channels) {
			LoadChannels(dispatch, user.OrganizationID)
		}
		getchannelContacts()
		getAllCustomFields()
	}, [])

	useEffect(() => {
		let ActiveSubOption = activeChannel.SubOptions?.find(x => x.Active === true)
		setRowData(Channels?.find(x => x.ID === ActiveSubOption?.ID)?.Status === ChannelAccountStatus.CONNECTED ? channelContactsData?.filter(x => x.ChannelId === ActiveSubOption.ID) : [])
		setHeaderCount(`${(Channels?.find(x => x.ID === ActiveSubOption?.ID)?.Status === ChannelAccountStatus.CONNECTED ? channelContactsData?.filter(x => x.ChannelId === ActiveSubOption.ID) : []).length} contacts`)
	}, [channelContactsData, activeChannel])

	useEffect(() => {
		setHeaderTitle(pageTitles.CONTACTS);
		setRefreshHandler(gridRefresh)
		setHeaderCount(`0 contacts`)
		return setHeaderTitle
	}, [])

	const getAllCustomFields = () => {
		ChannelContactServices.getAllCustomFields(user.OrganizationID).then(res => {
			let CustomGridColumns = res.data.map(x => mapToCustomFields(x)).map(x => {
				return {
					field: x.Name,
					headerName: x.Name,
					valueGetter: (params: ValueGetterParams) => {
						return params.data.CustomFields?.find(y => y.Name === x.Name)?.Type === "Date (DD/MM/YY)" ? params.data.CustomFields?.find(y => y.Name === x.Name)?.Value ? UtilityService.convertToDateTimeFormat(params.data.CustomFields?.find(y => y.Name === x.Name)?.Value) : "" : params.data.CustomFields?.find(y => y.Name === x.Name)?.Value
					},
					hide: !x.View,
				}
			})
			setCustomGridColumns(IsMobileDevice ? [] : CustomGridColumns)
			SetCustomFields(res.data.map(x => mapToCustomFields(x)))
			SetViewFields(res.data.map(x => mapToCustomFields(x)))
			setShowAllCustomFields(res.data.map(x => mapToCustomFields(x)).find(x => x.View === false) ? false : true)
		}).catch(() => { })
	}

	const getchannelContacts = () => {
		SetLoadingChannelContactsData(true)
		ChannelContactServices.getAllChannelContacts(user.OrganizationID).then(
			(res) => {
				SetChannelContactsData(res.data.map(x => mapToChannelContactItem(x)))
				SetLoadingChannelContactsData(false)
			}
		).catch(() => { SetLoadingChannelContactsData(false) })
	}

	const gridRefresh = () => {
		getchannelContacts()
		getAllCustomFields()
		if (!!gridApi) {
			gridApi.refreshCells({ force: true })
		}
	}

	const openChannelEditContact = (contact?: ChannelContactModel) => {
		setChannelContactToEdit(contact)
		setShowEditChannelContactEdit(true)
	}

	const closeChannelEditContact = (isConfim: boolean) => {
		setShowEditChannelContactEdit(false)
		setChannelContactToEdit(undefined)
		setMobileMenu(false);

		if (isConfim) {
			getchannelContacts()
		}
	}

	const onGridReady = (params) => {
		setGridApi(params.api)
	}

	const globalSearch = (e: any) => {
		gridApi.setQuickFilter(e.target.value)
	};

	const handleSearch = (value) => {
		gridApi.setQuickFilter(value)
	};

	const handleRowClick = (row: ChannelContactModel) => {
		if (IsMobileDevice) {
			setMobileMenu(true);
			setContactToEdit(row);
		}
	}

	const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => getchannelContacts())

	const handleSideBarWidth = (number) => {
		setSidebarWidth(number)
	}

	const handleChannelOptions = (ChannelOptions) => {
		let ActiveChannel = ChannelOptions.find(x => x.Active === true)
		let ActiveSubOption = ActiveChannel.SubOptions?.find(x => x.Active === true)
		setChannelOptions(ChannelOptions)
		setRowData(ActiveSubOption ? Channels.find(x => x.ID === ActiveSubOption.ID).Status === ChannelAccountStatus.CONNECTED ? channelContactsData.filter(x => x.ChannelId === ActiveSubOption.ID) : [] : channelContactsData.filter(x => x.PrimaryChannel === ActiveChannel.ChannelType))
		setHeaderCount(`${(ActiveSubOption ? Channels.find(x => x.ID === ActiveSubOption.ID).Status === ChannelAccountStatus.CONNECTED ? channelContactsData.filter(x => x.ChannelId === ActiveSubOption.ID) : [] : channelContactsData.filter(x => x.PrimaryChannel === ActiveChannel.ChannelType)).length} contacts`)
		setActiveChannel(ActiveChannel)
	}

	const handleOpenChat = (data: ChannelContactModel) => {
		let id = ""
		if (activeChannel.ChannelType === ChannelType.FACEBOOK) {
			id = data.FacebookId
		}
		else if (activeChannel.ChannelType === ChannelType.INSTAGRAM) {
			id = data.InstagramId
		}
		else if (activeChannel.ChannelType === ChannelType.LIVE_CHAT) {
			id = data.LiveChatId
		}
		else if (activeChannel.ChannelType === ChannelType.GOOGLE_BUSINESS) {
			id = data.GoogleId
		}
		else if (activeChannel.ChannelType === ChannelType.WHATSAPP) {
			id = data.WhatsappId
		}
		navigate(`/conversations/${id}`)
	}

	const closeCustomField = () => {
		setOpenCustomField(false)
	}

	const handleCustomFieldView = (id: string) => {
		let fields = viewFields.map(x => x.ID === id ? { ...x, View: !x.View } : x)
		setShowAllCustomFields(fields.find(x => x.View === true) ? fields.find(x => x.View === false) ? false : true : false)
		SetViewFields(viewFields.map(x => x.ID === id ? { ...x, View: !x.View } : x))
	}

	const closeViewField = () => {
		setOpenViewField(false)
		SetViewFields(customFields)
		setShowAllCustomFields(customFields.find(x => x.View === true) ? customFields.find(x => x.View === false) ? false : true : false)
	}

	const handleShowAllCustomFields = (value: boolean) => {
		setShowAllCustomFields(value)
		SetViewFields(value ? viewFields.map(x => { return { ...x, View: true } }) : viewFields.map(x => { return { ...x, View: false } }))
	}

	const handleUpdateViewFields = () => {
		setIsLoading(true)
		ChannelContactServices.updateCustomFields(user.OrganizationID, viewFields).then(() => {
			setIsLoading(false);
			setOpenViewField(false);
			getAllCustomFields();
		}).catch(() => { })
	}

	const handlePage = (page) => {
		const initialActiveChannel = channelOptions.find(x => x.Active === true)
		setActiveChannel({ ...activeChannel, SubOptions: activeChannel.SubOptions.map(x => { return { ...x, Active: x.ID === page.ID } }) })
		setChannelOptions(initialChannelOptions.map(x => x.Label === initialActiveChannel.Label ? { Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: false, SubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: initialActiveChannel.Icon, ActiveIcon: initialActiveChannel.ActiveIcon, Active: true, SubOptionsOpen: false } : x))
	}

	return (
		<PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh}>

			<div className="d-flex flex-direction h-p-100 o-hidden justify-between">
				{!IsMobileDevice ?
					<div className='w-p-96 mx-auto'>
						<PageHeaderComponent
							Reload={() => getchannelContacts()}
							Actions={
								[
									{
										OnClick: () => setOpenCustomField(true),
										ButtonLabel: buttonLabels.CUSTOM_FIELD,
										Icon: AddContactIcon,
										ClassName: "mr-2",
										Variant: "primary-btn",
									},
									{
										OnClick: () => setOpenViewField(true),
										ButtonLabel: "View",
										ClassName: "",
										Variant: "secondary-btn",
									}
								]}
							onSearch={globalSearch}
							PlaceHolder={"Find a Contact..."}
						/>
					</div> :
					<Grid className='px-1 mb-1'>
						<PageHeaderComponent
							Reload={() => getchannelContacts()}
							HideSearch={true}
							PlaceHolder={"Find a Contact..."}
						/>
						<ConversationCardsHeader handleSearch={handleSearch} pages={!!activeChannel.SubOptions?.length ? activeChannel.SubOptions : []} activePage={!!activeChannel.SubOptions?.length ? activeChannel.SubOptions?.find(x => x.Active) : ""} handlePage={handlePage} SelectChannel={true} ChannelOptions={channelOptions} handleChannelOptions={handleChannelOptions} HideFilter={true} />
					</Grid>

				}
				<div className={`w-p-100 h-p-100 d-flex justify-center align-center  ${IsMobileDevice ? "" : "bg-color-secondary"}`}>
					<div className="w-p-96 h-p-100 bg-color-side-bar br-3 d-flex o-hidden">
						{!IsMobileDevice && <div className={`min-w-${sidebarWidth} d-flex align-center justify-center h-p-96 my-auto ml-2 select-channel-active-border br-2`}>
							<SelectChannelSideBarComponent Options={channelOptions} handleSidebarWidth={handleSideBarWidth} handleOptions={handleChannelOptions} />
						</div>
						}
						{(Channels.length && channelOptions.find(x => x.Active)?.SubOptions.length && !loadingChannelContactsData) ?
							<div className={`${IsMobileDevice ? "w-p-100" : `flex-1`}  h-p-100`}>
								<GridComponent
									ColumnDefs={ChannelContactColumnDefs}
									IsPaginationEnabled={IsMobileDevice ? false : true}
									OnGridReady={onGridReady}
									RowData={rowData}
									OnGridRowClick={handleRowClick}
									EmptyLabel={(Channels.find(x => x?.ID === activeChannel.SubOptions?.find(x => x.Active)?.ID)?.Status === ChannelAccountStatus.DISCONNECTED || Channels.find(x => x?.ID === activeChannel.SubOptions?.find(x => x.Active)?.ID)?.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY) ?
										(
											<div>
												<div className='mb-2'><img src={LivechatDisconnectedIcon} alt="" /></div>
												<span><Link to={AppRoutes.CHANNELS} className="color-primary-link"> {activeChannel.SubOptions.find(x => x.Active)?.Label}</Link> has been disconnected,Connect the channel to view contacts.</span>
											</div>
										)
										: (Channels.find(x => x?.ID === activeChannel.SubOptions?.find(x => x.Active)?.ID)?.Status === ChannelAccountStatus.VALIDATION_PENDING || Channels.find(x => x?.ID === activeChannel.SubOptions?.find(x => x.Active)?.ID)?.Status === ChannelAccountStatus.VALIDATION_PENDING_BY_PLAN_EXPIRY) ?
											(
												<div>
													<div className='mb-2'><img src={LivechatValidationPendingIcon} alt="" /></div>
													<span><Link to={AppRoutes.CHANNELS} className="color-primary-link"> {activeChannel.SubOptions?.find(x => x.Active)?.Label}</Link> validation is pending,Connect the channel to view contacts.</span>
												</div>
											)
											: <div>
												<div className="mt-8"><ChannelsGridEmptyIcon /></div>
												<span className="h5-medium">{emptyLabels.CONTACTS}</span>
											</div>}
									LockVisible={IsMobileDevice}
									filterOptions={filterOptions}
									IsFilterPresent={false}
								/>
							</div>
							:
							<div className={`bg-color-secondary flex-1 h-p-96 my-auto mr-2 select-channel-active-border br-2 ml-2`}>
								{(LoadingChannels || loadingChannelContactsData) ?
									<NoDataComponent Message={"Please wait while we fetch contacts for you..."} />
									:
									<NoDataComponent Message={<div>To see and manage contacts, first <span className="color-primary-light mx-1 c-pointer w-space" onClick={() => navigate(AppRoutes.ADD_CHANNELS)}>Add a Channel</span> Once active, customer profiles will be created automatically as conversations begin.</div>} />
								}
							</div>
						}
					</div>
				</div>

				{
					showChannelContactEdit &&
					<ChannelEditContactComponent show={showChannelContactEdit} onClose={closeChannelEditContact} Contact={channelContactToEdit} />
				}

				{openCustomField &&
					<ContactAddCustomField
						GetchannelContacts={() => { getchannelContacts(); getAllCustomFields() }}
						CloseCustomField={() => closeCustomField()}
					/>
				}

				{openViewField &&
					<Dialog
						fullWidth
						onClose={() => closeViewField()}
						aria-labelledby="responsive-dialog-title"
						open={openViewField}
						classes={{ paper: "br-1 w-p-30 min-w-50 dialogue-shadow bg-color-secondary" }}
					>
						<DialogTitle id="alert-dialog-title" className="dialog-header">
							<div className='d-flex'>
								<span className={"h2-regular color-text-field-font"}>Select Fields To View</span>
								<Tooltip title='Close' placement='bottom'>
									<CancelIcon className={"c-pointer ml-auto"} onClick={() => closeViewField()} />
								</Tooltip>
							</div>
						</DialogTitle>
						<DialogContent className='py-1 px-3'>
							<Grid container direction="row" spacing={1} className="">
								< Grid item xs={12} >
									<FormControlLabel classes={{ label: 'h4-medium w-space color-primary-accent ' }} control={
										<Checkbox
											checked={showAllCustomFields}
											value={showAllCustomFields}
											size='small'
											onChange={() => handleShowAllCustomFields(!showAllCustomFields)}
											classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }} />}
										label={"Show All"}
									/>
								</Grid>
								{[{ Header: "Name", Selected: true }, { Header: "Email", Selected: true }, { Header: "First Connected", Selected: true }, { Header: "Last Connected", Selected: true }, { Header: "Chat", Selected: true }].map((x) => {
									return < Grid item xs={6} >
										<FormControlLabel classes={{ label: 'h4-medium w-space color-primary-accent ' }} control={
											<Checkbox
												checked={x.Selected}
												value={x.Header}
												size='small'
												classes={{ checked: "disabled", indeterminate: "selected-checkbox" }}
											/>}
											label={x.Header}
										/>
									</Grid>
								})
								}
								{viewFields.map(x => {
									return < Grid item xs={6} >
										<FormControlLabel classes={{ label: 'h4-medium w-space color-primary-accent ' }} control={
											<Checkbox
												checked={x.View}
												value={x.View}
												onChange={() => handleCustomFieldView(x.ID)}
												size='small'
												classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }} />}
											label={x.Name}
										/>
									</Grid>
								}
								)
								}
							</Grid>
							<Grid item xs={12}>
								<div className="d-flex float-right pt-3">
									<ButtonComponent Type={"submit"} OnClick={() => { handleUpdateViewFields() }} ButtonLabel={buttonLabels.SAVE} ClassName={"px-4 mr-1"} Variant={"primary-btn-small"} Loading={isLoading} />
									<ButtonComponent OnClick={() => closeViewField()} ButtonLabel={buttonLabels.CANCEL} ClassName={""} Variant={"secondary-btn-small"} /></div>
							</Grid>
						</DialogContent>
					</Dialog>
				}
				{mobileMenu && IsMobileDevice && contactToEdit !== null && (
					<Dialog
						fullWidth
						onClose={() => closeChannelEditContact(false)}
						aria-labelledby="responsive-dialog-title"
						open={true}
						classes={{ paper: "br-2 dialogue-shadow w-p-70 bg-color-menu-bg" }}
					>
						<DialogTitle className="dialog-header pb-1">
							<div className="h1 color-display-title d-flex" id="customized-dialog-title">
								{!!contactToEdit?.FirstName && UtilityService.trimMessage(contactToEdit?.FirstName, 16)}
								<span className="ml-auto">
									<Tooltip
										title="Close"
										placement="bottom"
										enterTouchDelay={0}
									>
										<CancelIcon
											className={"c-pointer"}
											onClick={(e: any) => {
												e.stopPropagation();
												closeChannelEditContact(false);
											}}
										/>
									</Tooltip>
								</span>
							</div>
						</DialogTitle>
						<DialogContent className={"mln-1 o-hidden pt-0"}>
							<MenuItemRenderer MenuData={getChannelMenuActions(contactToEdit)} OnClick={() => openChannelEditContact(contactToEdit)} />
						</DialogContent>
					</Dialog>
				)}
			</div>
		</PullToRefresh >
	)
}
export default ContactsComponent;
